
import * as noneRuntime$B3TyT0Ws8zPRPKGtONKiyO2kP3_459K5RZXt19lS4FHIo from '/Users/demir/projects/inanctur/inanctur.com.tr/node_modules/@nuxt/image/dist/runtime/providers/none'

export const imageOptions = {
  "screens": {
    "xs": 360,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1380,
    "xxl": 1536,
    "2xl": 1920
  },
  "presets": {},
  "provider": "none",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "avif",
    "webp",
    "webp"
  ],
  "quality": 70
}

imageOptions.providers = {
  ['none']: { provider: noneRuntime$B3TyT0Ws8zPRPKGtONKiyO2kP3_459K5RZXt19lS4FHIo, defaults: {} }
}
        